module.exports = "../static/images/045a4b.png";